import { useTranslation } from "react-i18next"
import { Trash } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { Card, CardHeader, CardHeaderTitle } from "@/components/ui/card"
import { useRemoveAllAppointmentsMutation } from "@/modules/admin/advanced/services/useRemoveAllAppointmentsMutation"
import { useConfirmStore } from "@/stores/useConfirmStore"

export const DeleteAllAppointments = () => {
  const { t } = useTranslation()
  const [removeAllAppointments, isRemoving] = useRemoveAllAppointmentsMutation()

  const confirm = useConfirmStore((state) => state.confirm)
  const cancel = useConfirmStore((state) => state.cancel)

  const onDelete = () => {
    confirm({
      title: t("admin.advanced.deleteAllAppointments.title"),
      content: "",
      cancelText: t("common.button.cancel"),
      confirmText: t("common.button.delete"),
      onConfirm: () => {
        removeAllAppointments()
        cancel()
      },
    })
  }

  return (
    <Card className="h-fit w-92.5">
      <CardHeader>
        <CardHeaderTitle data-testid="card-header-title-content" className="flex items-center gap-4">
          {t("admin.advanced.deleteAllAppointments.title")}
        </CardHeaderTitle>
        <div className="flex justify-end">
          <Button variant="tertiary" isLoading={isRemoving} className="p-2" onClick={onDelete}>
            <Trash className="text-on-surface-subdued" />
          </Button>
        </div>
      </CardHeader>
    </Card>
  )
}
